import axios from "axios";
export async function postTags(e, tagName, op) {
  e.preventDefault();
  let options="";
  if(op){
    options="create"
  }else{
    options="delete";
  }
  const uri = "/profile/bookmark";
  await axios.post(uri, {
    op:options,
    asset_type:"tag",
    asset_value:tagName
  })
    .then(res => console.log("response", res))
    .catch(err => console.log(err));
}
